<template>
  <div>
    <!-- FAB + Popover: Mas Sistemas -->
    <v-menu
      v-model="menuSistemas"
      :close-on-content-click="false"
      offset-x
      left
      :nudge-width="260"
      :max-width="300"
    >
      <template v-slot:activator="{ on: menuOn }">
        <v-tooltip left>
          <template v-slot:activator="{ on: tipOn }">
            <v-btn
              v-on="{ ...menuOn, ...tipOn }"
              fab
              dark
              large
              :color="estaLogueado ? '#43A047' : '#1a73e8'"
              :style="{
                position: 'fixed',
                bottom: $vuetify.breakpoint.xs ? '20px' : '30px',
                right: $vuetify.breakpoint.xs ? '20px' : '30px',
                zIndex: 999
              }"
            >
              <v-icon>{{ estaLogueado ? 'mdi-account-circle' : 'mdi-apps' }}</v-icon>
            </v-btn>
          </template>
          <span>Más sistemas</span>
        </v-tooltip>
      </template>

      <v-card min-width="220" class="pa-2">
        <v-list-item
          @click="abrirBlog"
          style="border-radius: 8px; cursor: pointer;"
          class="mb-1"
        >
          <v-list-item-avatar>
            <v-icon color="teal" large>mdi-post-outline</v-icon>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title class="font-weight-bold" style="font-size: 14px;">
              Blog
            </v-list-item-title>
            <v-list-item-subtitle style="font-size: 12px;">
              Artículos y publicaciones
            </v-list-item-subtitle>
          </v-list-item-content>
          <v-list-item-action>
            <v-icon color="grey">mdi-chevron-right</v-icon>
          </v-list-item-action>
        </v-list-item>

        <v-list-item
          @click="abrirStore"
          style="border-radius: 8px; cursor: pointer;"
          class="mb-1"
        >
          <v-list-item-avatar>
            <v-icon color="#6A76AB" large>mdi-store</v-icon>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title class="font-weight-bold" style="font-size: 14px;">
              TecZoa Store
            </v-list-item-title>
            <v-list-item-subtitle style="font-size: 12px;">
              Productos y servicios.
            </v-list-item-subtitle>
          </v-list-item-content>
          <v-list-item-action>
            <v-icon color="grey">mdi-chevron-right</v-icon>
          </v-list-item-action>
        </v-list-item>

        <v-list-item
          @click="abrirLinksTec"
          style="border-radius: 8px; cursor: pointer;"
          class="mt-1"
        >
          <v-list-item-avatar>
            <v-icon color="#1a73e8" large>mdi-link-variant</v-icon>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title class="font-weight-bold" style="font-size: 14px;">
              Links Tec
            </v-list-item-title>
            <v-list-item-subtitle style="font-size: 12px;">
              Gestor de enlaces y perfiles
            </v-list-item-subtitle>
          </v-list-item-content>
          <v-list-item-action>
            <v-icon color="grey">mdi-open-in-new</v-icon>
          </v-list-item-action>
        </v-list-item>

        <v-divider class="my-2"></v-divider>

        <v-list-item
          @click="irAlCarrito"
          style="border-radius: 8px; cursor: pointer;"
        >
          <v-list-item-avatar>
            <v-badge :content="badgeCarrito" :value="cantidadCarrito > 0" color="red" overlap>
              <v-icon color="orange darken-2" large>mdi-cart</v-icon>
            </v-badge>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title class="font-weight-bold" style="font-size: 14px;">
              Mi Carrito
            </v-list-item-title>
            <v-list-item-subtitle style="font-size: 12px;">
              Ver pedidos en memoria
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>

        <v-divider class="my-2"></v-divider>

        <v-list-item
          @click="abrirLogin"
          style="border-radius: 8px; cursor: pointer;"
        >
          <v-list-item-avatar>
            <v-icon color="#1a73e8" large>mdi-login</v-icon>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title class="font-weight-bold" style="font-size: 14px;">
              Iniciar sesión
            </v-list-item-title>
            <v-list-item-subtitle style="font-size: 12px;">
              Accedé a tu cuenta
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>

        <v-divider class="my-1"></v-divider>

        <v-list-item
          @click="abrirRegister"
          style="border-radius: 8px; cursor: pointer;"
        >
          <v-list-item-avatar>
            <v-icon color="#43A047" large>mdi-account-plus</v-icon>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title class="font-weight-bold" style="font-size: 14px;">
              Registrarse
            </v-list-item-title>
            <v-list-item-subtitle style="font-size: 12px;">
              Creá una cuenta nueva
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>

        <v-divider class="my-1" v-if="estaLogueado"></v-divider>

        <v-list-item
          v-if="estaLogueado"
          @click="irAMiCuenta"
          style="border-radius: 8px; cursor: pointer;"
        >
          <v-list-item-avatar>
            <v-icon color="#1a73e8" large>mdi-account-cog</v-icon>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title class="font-weight-bold" style="font-size: 14px;">
              Mi Cuenta
            </v-list-item-title>
            <v-list-item-subtitle style="font-size: 12px;">
              Datos de usuario
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>

        <v-list-item
          v-if="estaLogueado"
          @click="irAMisPedidos"
          style="border-radius: 8px; cursor: pointer;"
        >
          <v-list-item-avatar>
            <v-icon color="#00897B" large>mdi-clipboard-list</v-icon>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title class="font-weight-bold" style="font-size: 14px;">
              Mis Pedidos
            </v-list-item-title>
            <v-list-item-subtitle style="font-size: 12px;">
              Estado de mis pedidos
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>

        <v-divider class="my-1" v-if="estaLogueado"></v-divider>

        <v-list-item
          v-if="estaLogueado"
          @click="cerrarSesion"
          style="border-radius: 8px; cursor: pointer;"
        >
          <v-list-item-avatar>
            <v-icon color="red darken-1" large>mdi-logout</v-icon>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title class="font-weight-bold" style="font-size: 14px;">
              Cerrar sesión
            </v-list-item-title>
            <v-list-item-subtitle style="font-size: 12px;">
              Salir de tu cuenta
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-card>
    </v-menu>

    <LoginCarrito v-model="dialogLogin" @cambiar-a-registro="irARegistro" @login-exitoso="onLoginExitoso" />
    <RegisterCarrito v-model="dialogRegister" @cambiar-a-login="irALogin" @registro-exitoso="onRegistroExitoso" />

    <v-snackbar v-model="snackbar.show" :timeout="4000" :color="snackbar.color" text>
      {{ snackbar.text }}
      <template v-slot:action="{ attrs }">
        <v-btn icon small v-bind="attrs" @click="snackbar.show = false">
          <v-icon small>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import LoginCarrito from '@/components/tienda/carrito/LoginCarrito'
import RegisterCarrito from '@/components/tienda/carrito/RegisterCarrito'

export default {
  name: 'BotonFlotanteTienda',

  components: {
    LoginCarrito,
    RegisterCarrito
  },

  computed: {
    estaLogueado() {
      return this.$store.getters.estaLogueado;
    },
    cantidadCarrito() {
      return this.$store.getters.cantidadCarrito;
    },
    badgeCarrito() {
      return this.cantidadCarrito > 99 ? '99+' : String(this.cantidadCarrito);
    }
  },

  data() {
    return {
      menuSistemas: false,
      dialogLogin: false,
      dialogRegister: false,
      snackbar: { show: false, text: '', color: '' }
    };
  },

  methods: {
    abrirStore() {
      this.menuSistemas = false;
      if (this.$route.path !== '/store/all') {
        this.$router.push('/store/all');
      }
    },
    abrirBlog() {
      this.menuSistemas = false;
      if (this.$route.path !== '/blog') {
        this.$router.push('/blog');
      }
    },
    abrirLinksTec() {
      this.menuSistemas = false;
      window.open('/linkstec', '_blank');
    },
    irAlCarrito() {
      this.menuSistemas = false;
      if (this.$route.path !== '/store-carrito') {
        this.$router.push('/store-carrito');
      }
    },
    abrirLogin() {
      this.menuSistemas = false;
      this.dialogLogin = true;
    },
    abrirRegister() {
      this.menuSistemas = false;
      this.dialogRegister = true;
    },
    irARegistro() {
      this.dialogLogin = false;
      this.$nextTick(() => { this.dialogRegister = true; });
    },
    irALogin() {
      this.dialogRegister = false;
      this.$nextTick(() => { this.dialogLogin = true; });
    },

    cerrarSesion() {
      this.menuSistemas = false;
      localStorage.removeItem('token');
      this.$store.commit('vaciarCarrito');
      this.$store.commit('setLogueado', false);
      this.$store.commit('setIdentificador', '');
      this.$store.commit('setLinkPhoto', '');
      this.snackbar = { show: true, text: 'Sesión cerrada correctamente', color: 'info' };
    },
    irAMiCuenta() {
      this.menuSistemas = false;
      this.$router.push('/data_user');
    },
    irAMisPedidos() {
      this.menuSistemas = false;
      this.$router.push('/mis-pedidos');
    },
    onLoginExitoso() {
      this.snackbar = { show: true, text: 'Sesión iniciada correctamente', color: 'success' };
    },
    onRegistroExitoso() {
      this.snackbar = { show: true, text: 'Cuenta creada correctamente', color: 'success' };
    }
  }
};
</script>
